/* eslint-disable react/no-unescaped-entities */
import FooterV2 from "@/components/Home/v2/FooterV2";
import NavbarV2 from "@/components/Home/v2/NavbarV2";
import { homeV2Data } from "@/shared/data/home.v2.data";
import { LegalPageSlugEnum } from "@/shared/types/common.types";
import { getPageBySlug } from "@/shared/utils/markdown.utils";
import { GetStaticPaths, GetStaticProps, InferGetStaticPropsType } from "next";
import Head from "next/head";

export const getStaticPaths: GetStaticPaths = async () => {
  const paths: { params: { [key: string]: any }; locale: string }[] = [];

  Object.values(LegalPageSlugEnum).forEach((legalPageSlug) => {
    paths.push(
      { params: { legalPageSlug }, locale: "en" },
      { params: { legalPageSlug }, locale: "us" },
      { params: { legalPageSlug }, locale: "kr" }
    );
  });

  return { paths, fallback: false };
};

export const getStaticProps: GetStaticProps<{
  pageData: {
    metaTitle: string;
    metaDescription: string;
    title: string;
    lastUpdated: string;
    content: string;
  };
}> = async (context) => {
  const legalPageSlug = context.params?.legalPageSlug as LegalPageSlugEnum;
  const locale = (context.locale as "en" | "kr" | "us") ?? "en";

  try {
    const pageData = await getPageBySlug(
      legalPageSlug,
      ["metaTitle", "metaDescription", "title", "lastUpdated", "content"],
      locale
    );

    return { props: { pageData } };
  } catch {
    return { notFound: true };
  }
};

export default function LegalPage({
  pageData,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <div className="home-v2-scope min-h-screen bg-white">
      <Head>
        <title>{pageData.metaTitle}</title>
        <meta name="description" content={pageData.metaDescription} />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head>

      <NavbarV2 />

      <main className="prose mx-auto my-24 max-w-3xl px-4 text-justify leading-relaxed prose-h1:text-center prose-h2:text-center prose-a:text-dashDark prose-a:no-underline prose-ol:list-decimal">
        <h1 className="mx-auto mb-4 text-center font-extrabold text-black">
          {pageData.title}
        </h1>
        {pageData.lastUpdated && (
          <h4 className="text-center uppercase tracking-ultrawide text-black">
            LAST UPDATED: {pageData.lastUpdated}
          </h4>
        )}
        <div dangerouslySetInnerHTML={{ __html: pageData.content }} />
      </main>

      <FooterV2 {...homeV2Data.footer} />
    </div>
  );
}
